import { render, staticRenderFns } from "./HintDescriptionTitle.vue?vue&type=template&id=70fcff12&scoped=true&"
import script from "./HintDescriptionTitle.vue?vue&type=script&lang=js&"
export * from "./HintDescriptionTitle.vue?vue&type=script&lang=js&"
import style0 from "./HintDescriptionTitle.vue?vue&type=style&index=0&id=70fcff12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fcff12",
  null
  
)

export default component.exports